module.exports = __webpack_public_path__ + "static/media/ThisWaytoHappy_Bookcover.6dc4b9b5.jpg";